declare const bishokuAjax: { url: string; nonce: string };

export function initHomeSearch(): void {
  const form = document.querySelector<HTMLFormElement>(
    '.search-restaurant form[data-home-search]'
  );
  if (!form) return;

  const resultEl = document.querySelector<HTMLElement>('.home-search-result');
  if (!resultEl) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    formData.append('action', 'bishoku_home_search');
    formData.append('nonce', bishokuAjax.nonce);
    // UI専用フィールドは送信不要
    formData.delete('area-category');
    formData.delete('area-category-sp');

    resultEl.removeAttribute('hidden');
    resultEl.innerHTML = '<p class="loading">検索中...</p>';
    resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

    let json: { success: boolean; data: { html: string; total: number; search_url: string } };
    try {
      const res = await fetch(bishokuAjax.url, { method: 'POST', body: formData, credentials: 'include' });
      json = await res.json();
    } catch {
      resultEl.innerHTML = '<p class="no-results">通信エラーが発生しました。</p>';
      return;
    }

    if (!json.success) {
      resultEl.innerHTML = '<p class="no-results">エラーが発生しました。</p>';
      return;
    }

    const { html, total, search_url } = json.data;

    let out = `<div class="counter">検索結果：${total}件</div>`;

    if (total === 0) {
      resultEl.innerHTML =
        out + '<p class="no-results">店舗は見つかりませんでした<br>検索条件を変更してください</p>';
      return;
    }

    out += `<ul class="restaurant">${html}</ul>`;
    if (total > 5) {
      out += `<div class="link"><a href="${search_url}">検索結果をすべて見る</a></div>`;
    }
    resultEl.innerHTML = out;
  });
}
